<template>
<svg  id="robot" viewBox="0 0 470 600" fill="none" shape-rendering="geometricPrecision" xmlns="http://www.w3.org/2000/svg">
      <!-- 天线开始 -->
    <g id="&#229;&#164;&#169;&#231;&#186;&#191;" width="82" height="107" viewBox="0 0 82 107" transform="translate(193, 0)">
        <g>
            <rect id="&#229;&#164;&#169;&#231;&#186;&#191;_2" x="33.5" y="62.5" width="15" height="44" fill="url(#paint0_linear_1087_7376)" stroke="white"/>
            <g id="&#228;&#191;&#161;&#229;&#143;&#183;">
                <g id="Ellipse 78" filter="url(#filter0_d_1087_7376)">
                <circle cx="41" cy="37" r="33" fill="url(#paint1_radial_1087_7376)"/>
                <circle cx="41" cy="37" r="32.5" stroke="white"/>
                </g>
                <g id="Z" filter="url(#filter1_d_1087_7376)">
                <path d="M30.494 48.0004C30.19 48.0004 30 47.8104 30 47.5064V46.2144C30 45.9864 30.076 45.7964 30.19 45.6064L43.034 29.9344H31.064C30.76 29.9344 30.57 29.7444 30.57 29.4404V25.6024C30.57 25.2984 30.76 25.1084 31.064 25.1084H50.33C50.634 25.1084 50.824 25.2984 50.824 25.6024V26.8944C50.824 27.1224 50.748 27.3124 50.634 27.5024L37.79 43.1744H50.596C50.9 43.1744 51.09 43.3644 51.09 43.6684V47.5064C51.09 47.8104 50.9 48.0004 50.596 48.0004H30.494Z" fill="url(#paint2_linear_1087_7376)"/>
                </g>
            </g>
            <animateTransform 
            attributeName="transform"
            type="rotate"
            values="0 41 107; 40 41 107; 0 41 107; -40 41 107; 0 41 107"
            keyTimes="0; 0.25; 0.5; 0.75; 1"
            dur="1s"
            repeatCount="indefinite"/>
        </g>
    </g>
    <defs>
        <filter id="filter0_d_1087_7376" x="0" y="0" width="82" height="82" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="4"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.764075 0 0 0 0 0.8563 0 0 0 0 0.965902 0 0 0 1 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1087_7376"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1087_7376" result="shape"/>
        </filter>
        <filter id="filter1_d_1087_7376" x="17" y="13.1084" width="47.0898" height="48.8916" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="6.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.16406 0 0 0 0 0.569498 0 0 0 0 0.948779 0 0 0 0.6 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1087_7376"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1087_7376" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_1087_7376" x1="36" y1="77.5" x2="59.4796" y2="77.0012" gradientUnits="userSpaceOnUse">
        <stop offset="0.005" stop-color="#DFFDFF"/>
        <stop offset="0.46" stop-color="#A3D7FC"/>
        <stop offset="1" stop-color="#167AFF"/>
        </linearGradient>
        <radialGradient id="paint1_radial_1087_7376" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(28 23.5) rotate(46.3062) scale(108.569 111.955)">
        <stop offset="0.135" stop-color="#EFFEFF"/>
        <stop offset="1" stop-color="#167AFF"/>
        </radialGradient>
        <linearGradient id="paint2_linear_1087_7376" x1="37.5" y1="29.5" x2="51" y2="47.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="#75B4FF"/>
        <stop offset="1" stop-color="#0F6CD9"/>
        </linearGradient>
    </defs>
    <!-- 天线结束 -->
    
    <!-- 左耳朵开始 -->
    <g id="&#229;&#183;&#166;&#232;&#128;&#179;" width="53" height="102" viewBox="0 0 53 102" transform="translate(0, 235)">
        <g filter="url(#filter0_i_1070_7581)">
            <path d="M53 0H40C17.9086 0 0 17.9086 0 40V62C0 84.0914 17.9086 102 40 102H53V0Z" fill="url(#paint0_linear_1070_7581)"/>
        </g>
        <path d="M52.5 0.5H40C18.1848 0.5 0.5 18.1848 0.5 40V62C0.5 83.8152 18.1848 101.5 40 101.5H52.5V0.5Z" stroke="url(#paint1_linear_1070_7581)" stroke-opacity="0.5"/>
    </g>
    <defs>
        <filter id="filter0_i_1070_7581" x="-4" y="-8" width="57" height="110" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-4" dy="-9"/>
        <feGaussianBlur stdDeviation="4"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1070_7581"/>
        </filter>
        <linearGradient id="paint0_linear_1070_7581" x1="26.5" y1="0" x2="26.5" y2="92.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="#F0F6FF"/>
        <stop offset="1" stop-color="#69A9FC"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1070_7581" x1="26.5" y1="0" x2="26.5" y2="102" gradientUnits="userSpaceOnUse">
        <stop stop-color="#91E2FF"/>
        <stop offset="1" stop-color="#1E81FF"/>
        </linearGradient>
    </defs>
    <!-- 左耳朵结束 -->
    
    <!-- 右耳朵开始 -->
    <g id="&#229;&#143;&#179;&#232;&#128;&#179;" width="53" height="102" viewBox="0 0 53 102" transform="translate(409, 235)">
        <g filter="url(#filter0_i_1070_7578)">
            <path d="M0 0H13C35.0914 0 53 17.9086 53 40V62C53 84.0914 35.0914 102 13 102H0V0Z" fill="url(#paint0_linear_1070_7578)"/>
        </g>
        <path d="M0.5 0.5H13C34.8152 0.5 52.5 18.1848 52.5 40V62C52.5 83.8152 34.8152 101.5 13 101.5H0.5V0.5Z" stroke="url(#paint1_linear_1070_7578)" stroke-opacity="0.5"/>
    </g>
    <defs>
        <filter id="filter0_i_1070_7578" x="-4" y="-8" width="57" height="110" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-4" dy="-9"/>
        <feGaussianBlur stdDeviation="4"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1070_7578"/>
        </filter>
        <linearGradient id="paint0_linear_1070_7578" x1="26.5" y1="0" x2="26.5" y2="92.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="#F0F6FF"/>
        <stop offset="1" stop-color="#69A9FC"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1070_7578" x1="26.5" y1="0" x2="26.5" y2="102" gradientUnits="userSpaceOnUse">
        <stop stop-color="#91E2FF"/>
        <stop offset="1" stop-color="#1E81FF"/>
        </linearGradient>
    </defs>
    <!-- 右耳朵结束 -->
    <!-- 头部开始 -->
    <!-- <g id="&#229;&#164;&#180;" filter="url(#filter0_d_1070_7567)" width="446" height="410" viewBox="0 0 446 410" transform="translate(10, 90)"> -->
    <g id="&#229;&#164;&#180;" fill="white" width="446" height="410" viewBox="0 0 446 410" transform="translate(10, 90)"> 
      <ellipse cx="223" cy="199" rx="203" ry="185" fill="url(#paint0_linear_1070_7567)"/>
    </g>
    <defs>
        <filter id="filter0_d_1070_7567" x="0" y="0" width="446" height="410" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="6"/>
        <feGaussianBlur stdDeviation="10"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1070_7567"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1070_7567" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_1070_7567" x1="136" y1="38" x2="294" y2="377" gradientUnits="userSpaceOnUse">
        <stop offset="0.005" stop-color="#DFFDFF"/>
        <stop offset="0.46" stop-color="#A3D7FC"/>
        <stop offset="1" stop-color="#167AFF"/>
        </linearGradient>
    </defs>
    <!-- 头部结束 -->

    <!-- 脸部开始 -->
    <g id="&#232;&#132;&#184;" filter="url(#filter0_di_1070_7577)" width="340" height="224" viewBox="0 0 340 224" transform="translate(60, 167)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0529 122.843C17.0178 123.724 17 124.61 17 125.5C17 149.452 29.8562 170.401 49.0445 181.823C64.268 194.063 112.212 203 169 203C217.687 203 259.872 196.431 280.511 186.844C305.334 177.528 323 153.577 323 125.5C323 124.61 322.982 123.724 322.947 122.843C322.982 121.898 323 120.951 323 120C323 60.9053 254.5 13 170 13C85.5 13 17 60.9053 17 120C17 120.951 17.0177 121.898 17.0529 122.843Z" fill="url(#paint0_linear_1070_7577)" shape-rendering="crispEdges"/>
        <!-- <path shape-rendering="crispEdges" d="M17.0529 122.843L17.5525 122.863L17.5533 122.843L17.5526 122.824L17.0529 122.843ZM49.0445 181.823L49.3578 181.434L49.3304 181.412L49.3002 181.394L49.0445 181.823ZM280.511 186.844L280.336 186.376L280.318 186.382L280.301 186.39L280.511 186.844ZM322.947 122.843L322.447 122.824L322.447 122.843L322.447 122.863L322.947 122.843ZM16.5533 122.823C16.5179 123.711 16.5 124.603 16.5 125.5H17.5C17.5 124.617 17.5176 123.737 17.5525 122.863L16.5533 122.823ZM16.5 125.5C16.5 149.635 29.4553 170.744 48.7887 182.253L49.3002 181.394C30.2571 170.058 17.5 149.268 17.5 125.5H16.5ZM48.7312 182.213C52.6035 185.326 58.5179 188.202 66.0631 190.769C73.6162 193.338 82.8366 195.609 93.3471 197.494C114.369 201.264 140.582 203.5 169 203.5V202.5C140.63 202.5 114.477 200.267 93.5237 196.509C83.0468 194.63 73.8777 192.371 66.3851 189.822C58.8846 187.271 53.0973 184.44 49.3578 181.434L48.7312 182.213ZM169 203.5C217.704 203.5 259.98 196.932 280.722 187.297L280.301 186.39C259.764 195.93 217.67 202.5 169 202.5V203.5ZM280.687 187.312C305.699 177.925 323.5 153.792 323.5 125.5H322.5C322.5 153.362 304.97 177.13 280.336 186.376L280.687 187.312ZM323.5 125.5C323.5 124.603 323.482 123.711 323.447 122.823L322.447 122.863C322.482 123.737 322.5 124.617 322.5 125.5H323.5ZM323.447 122.861C323.482 121.911 323.5 120.957 323.5 120H322.5C322.5 120.944 322.482 121.886 322.447 122.824L323.447 122.861ZM323.5 120C323.5 90.2445 306.254 63.3574 278.474 43.9297C250.693 24.501 212.34 12.5 170 12.5V13.5C212.16 13.5 250.307 25.4516 277.901 44.7492C305.496 64.0479 322.5 90.6608 322.5 120H323.5ZM170 12.5C127.66 12.5 89.3072 24.501 61.5259 43.9297C33.7463 63.3574 16.5 90.2445 16.5 120H17.5C17.5 90.6608 34.5037 64.0479 62.0991 44.7492C89.6928 25.4516 127.84 13.5 170 13.5V12.5ZM16.5 120C16.5 120.957 16.5178 121.911 16.5533 122.861L17.5526 122.824C17.5176 121.886 17.5 120.944 17.5 120H16.5Z" fill="url(#paint1_linear_1070_7577)"/> -->
        <animateTransform
        attributeName="transform"
        type="translate"
          values="0,0; 0,0;    0,-30;  0,-30;    0,0; 0,0"
        keyTimes="0;   0.2;     0.3;   0.7;       0.9; 1"
        begin="0s"
        dur="2s"
        additive="sum"
        accumulate="none"
        repeatCount="indefinite" />
    </g>
    <defs>
        <filter id="filter0_di_1070_7577" x="0.5" y="0.5" width="339" height="223" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="8"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.345098 0 0 0 0 0.65098 0 0 0 0 0.996078 0 0 0 0.28 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1070_7577"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1070_7577" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="16"/>
        <feGaussianBlur stdDeviation="8"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1070_7577"/>
        </filter>
        <linearGradient id="paint0_linear_1070_7577" x1="194.5" y1="16.5" x2="182" y2="198" gradientUnits="userSpaceOnUse">
        <stop stop-color="#B3F6FF"/>
        <stop offset="1" stop-color="white" stop-opacity="0.3"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1070_7577" x1="170" y1="13" x2="170" y2="203" gradientUnits="userSpaceOnUse">
        <stop stop-color="white" stop-opacity="0.3"/>
        <stop offset="1" stop-color="white" stop-opacity="0.7"/>
        </linearGradient>
    </defs>
    <!-- 脸部结束 -->

    <g>
        <!-- 左眼睛开始 -->
        <g id="&#229;&#183;&#166;&#231;&#156;&#188;" filter="url(#filter0_d_1070_7585)"  width="88" height="132" viewBox="0 0 88 132" transform="translate(134, 216)">
            <rect x="20" y="16" width="48" height="92" rx="24" fill="url(#paint0_linear_1070_7585)"/>
            <rect x="20.5" y="16.5" width="47" height="91" rx="23.5" stroke="white"/>
            <animateTransform
            attributeName="transform"
            type="translate"
            values="0,0;      0,57.95;  0,0;       0,57.95;   0,0;    0,0;     0,57.95;    0,0;       0,0"
            keyTimes="0;   0.025;    0.05; 0.075;  0.1; 0.6; 0.625;  0.65; 1"
            begin="0s"
            dur="2s"
            additive="sum"
            accumulate="none"
            repeatCount="indefinite" />
            <animateTransform
            attributeName="transform"
            type="scale"
            values="1,1;   1,0.1;  1,1;  1,0.1;  1,1; 1,1; 1,0.1;  1,1; 1,1"
            keyTimes="0;   0.025;  0.05; 0.075;  0.1; 0.6; 0.625;  0.65; 1"
            dur="2s"
            additive="sum"
            accumulate="none"
            repeatCount="indefinite" />
        </g>
        
        <defs>
            <filter id="filter0_d_1070_7585" x="0" y="0" width="88" height="132" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="10"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.196426 0 0 0 0 0.585872 0 0 0 0 0.966943 0 0 0 0.6 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1070_7585"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1070_7585" result="shape"/>
            </filter>
            <linearGradient id="paint0_linear_1070_7585" x1="37.5" y1="108" x2="37.5" y2="16" gradientUnits="userSpaceOnUse">
                <stop stop-color="#F2F2F2"/>
                <stop offset="0.7" stop-color="white"/>
            </linearGradient>
        </defs>
        <!-- 左眼睛结束 -->

        <!-- 右眼睛开始 -->
        <g id="&#229;&#143;&#179;&#231;&#156;&#188;" filter="url(#filter0_d_1070_7586)" width="88" height="132" viewBox="0 0 88 132" transform="translate(248, 216)">
            <rect x="20" y="16" width="48" height="92" rx="24" fill="url(#paint0_linear_1070_7586)"/>
            <rect x="20.5" y="16.5" width="47" height="91" rx="23.5" stroke="white"/>
            <animateTransform
            attributeName="transform"
            type="translate"
            values="0,0;      0,57.95;  0,0;       0,57.95;   0,0;    0,0;     0,57.95;    0,0;       0,0"
            keyTimes="0;   0.025;    0.05; 0.075;  0.1; 0.6; 0.625;  0.65; 1"
            begin="0s"
            dur="2s"
            additive="sum"
            accumulate="none"
            repeatCount="indefinite" />
            <animateTransform
            attributeName="transform"
            type="scale"
            values="1,1;   1,0.1;  1,1;  1,0.1;  1,1; 1,1; 1,0.1;  1,1; 1,1"
            keyTimes="0;   0.025;  0.05; 0.075;  0.1; 0.6; 0.625;  0.65; 1"
            dur="2s"
            additive="sum"
            accumulate="none"
            repeatCount="indefinite" />
        </g>
        <defs>
            <filter id="filter0_d_1070_7586" x="0" y="0" width="88" height="132" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="10"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.196426 0 0 0 0 0.585872 0 0 0 0 0.966943 0 0 0 0.6 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1070_7586"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1070_7586" result="shape"/>
            </filter>
            <linearGradient id="paint0_linear_1070_7586" x1="37.5" y1="108" x2="37.5" y2="16" gradientUnits="userSpaceOnUse">
            <stop stop-color="#F2F2F2"/>
            <stop offset="0.7" stop-color="white"/>
            </linearGradient>
        </defs>
        <!-- 右眼睛结束 -->
        <animateTransform
        attributeName="transform"
        type="translate"
          values="0,0; 0,0; -30,-30; -30, -30; 0,0; 0.0"
        keyTimes="0;   0.2;     0.3;     0.7; 0.9; 1"
        begin="0s"
        dur="2s"
        additive="sum"
        accumulate="none"
        repeatCount="indefinite" />
    </g>
    <!-- 投影开始 -->
    <ellipse id="&#230;&#138;&#149;&#229;&#189;&#177;" cx="115" cy="23" rx="115" ry="23" fill="url(#paint0_linear_1087_7374)" fill-opacity="0.3" transform="translate(116, 535)"/>
    <defs>
        <linearGradient id="paint0_linear_1087_7374" x1="65.7143" y1="2.98378" x2="70.9073" y2="53.7538" gradientUnits="userSpaceOnUse">
        <stop offset="0.005" stop-color="#DFFDFF"/>
        <stop offset="1" stop-color="#167AFF"/>
        </linearGradient>
    </defs>
    <!-- 投影结束 -->
</svg>

</template>
<script>
export default {
    data () {
        return{

        }
    },
    methods: {

    }
}
</script>
<style lang="scss">
.robot{
    fill: #ccc;
}
#robot{
    width :100%;
    height:auto;
}
</style>